import React, { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom'
import "../Header/Header.css"
const Header = () => {
  const [scrolled,setScrolled] = useState(false);
  const handleScroll = () =>{
    const offset = window.scrollY;
    if(offset > 100){
      setScrolled(true);
      
    }else{
      setScrolled(false);
    }
  }
  useEffect(() => {
    window.addEventListener("scroll",handleScroll);
  }, [])
  
  return (
    <header className={`header_content ${scrolled ? 'sticky_header' : ' '}`} >
    <div className="header">
      <div className="left">
        <NavLink to="/"><h2>TechnoBlitz</h2></NavLink>
      </div>
      <div className="mobile_menu">
      <div className="right">
        <NavLink to="/Events"><h5>Events</h5></NavLink>
        {/* <NavLink to="/Sponser"><h5>Sponser</h5></NavLink> */}
        {/* <NavLink to="/#About"><h5>About us</h5></NavLink> */}
        {/* <NavLink to="/#Contact"><h5>Contact Us</h5></NavLink> */}
      </div>
      </div>
    </div>
</header>
  )
}

export default Header